import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
// import { accountStore } from "./-store";

import { RouterContext } from "@/state/router";
export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
